module.exports = __webpack_public_path__ + "rx-logo.4b9b55c6.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/rx-logo.png
// module id = 666
// module chunks = 0